import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { SessionStorage } from 'ngx-webstorage';
@Injectable()
export class EmployeeGuard implements CanActivate, CanActivateChild {
  @SessionStorage() public user;
  @SessionStorage('x-access-token') public token;
  constructor(private router: Router) {

  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    let url: string = state.url;
    return this.checkLogin(url);
  }
  
  checkLogin(url: string): boolean {
    if (this.user && this.user.Role == 'EMP' && this.token) {
      this.router.navigate[url];
      return true;
    }

    this.router.navigate(['/']);
    return false;
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }
}



// WEBPACK FOOTER //
// ./src/app/employee/employee.guard.ts